import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '../static/frontend/index.css';
import * as Sentry from "@sentry/react";
// Inicializa o Sentry
Sentry.init({
    dsn: "https://3846ee28817e264a30eaca70120a502a@o4510563641720832.ingest.us.sentry.io/4510563715055616",
    sendDefaultPii: true,
    environment: process.env.NODE_ENV || "development",
    tracesSampleRate: 0.5,
});
document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('app');
    if (container) {
        createRoot(container).render(React.createElement(App, null));
    }
    else {
        console.error("Target container 'app' not found in the DOM.");
    }
});
